import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

class CloseTag extends React.PureComponent {
    onClickTagClose = () => {
        const { tag_item, disabled, handleTagClose } = this.props;
        if(!disabled){
            handleTagClose(tag_item);
        }
    };

    render() {
        const { container_class, label, disabled } = this.props;
        return (
            <div className={`ori-flex-row ${container_class}`} >
                <div className="ori-lr-pad-6 ori-font-xs">{label}</div>
                <div className="ori-lr-pad-5 ori-flex-column ori-flex-jc  ori-font-xxs" style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} onClick={this.onClickTagClose}>
                    <Icon type="close" />
                </div>
            </div>
        );
    }
}

CloseTag.propTypes = {
    container_class: PropTypes.string,
    tag_item: PropTypes.object,
    handleTagClose: PropTypes.func,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    disabled: PropTypes.bool,
};

CloseTag.defaultProps = {
    container_class: 'ori-border-light ori-border-radius-4 ori-bg-default',
    disabled: false,
};

export default CloseTag;



// WEBPACK FOOTER //
// ./src/components/closetag/index.js